import React from 'react';
import clsx from 'clsx';
import { Typography, Button } from '@ag1/ui';
import { NotificationProps } from './Notification.types';
import styles from './Notification.module.scss';

const Notification = (props: NotificationProps) => {
  const {
    title,
    description,
    icon: Icon,
    children,
    type = 'default',
    clickable,
    handleClick
  } = props;

  return (
    <div className={clsx(styles.root, styles[type], description && styles.withDescription)}>
      {Icon && (
        <div className={styles.iconWrap}>
          <Icon className={styles.icon} />
        </div>
      )}
      <div className={styles.contentContainer}>
        {clickable ? (
          <Button
            variant="link"
            onClick={handleClick}
            size="medium"
            className={styles.link}
            noPadding>
            {title}
          </Button>
        ) : (
          <Typography
            variant="portalText"
            size="1"
            weight="700"
            component="strong"
            className={styles.title}>
            {title}
          </Typography>
        )}
        {description && (
          <Typography variant="portalText" size="2" weight="400" className={styles.description}>
            {description}
          </Typography>
        )}
        {children}
      </div>
    </div>
  );
};

export default Notification;
